import { Translation } from "@payair/e-com-common-sdk/core/LanguageHandler"

const englishLanguage: Translation = {
  welcomeToClickToPay: "Welcome to Click to Pay",
  welcomeBackToClickToPay: "Welcome back to Click to Pay",
  fastSecureOnlineCheckout: "Fast, secure online checkout",
  weAccept: "We accept",
  getStarted: "Get started",
  emailAddress: "E-mail address",
  continue: "Continue",
  verify: "Verify",
  consentText:
    "I agree to share my details with Click to Pay to allow me to enroll in Click to Pay for faster checkouts.",
  rememberMe: "Remember me",
  rememberMeInBrowser: "Remember me in this browser",
  rememberMeMoreInformation: "More information about remembering this browser",
  rememberMeTooltipPrimary:
    "When remembered, you’ll skip verification and securely access your saved cards when paying with Click to Pay.",
  rememberMeTooltipWarning:
    "Not recommended for public or shared devices because this uses cookies.",
  notYou: "Not you?",
  clickToPay: "Click to Pay",
  existingAccount: "Looks that you already have a Click to Pay profile",
  otpInformation: "Enter the code sent to: ",
  otpTooShortCode: "Enter valid code (6 digits)",
  resend: "Resend",
  changeChannel: "Continue another way",
  selectCard: "Select a card to pay",
  addCard: "Add new card",
  expired: "expired",
  addToCTP: "Add to Click to Pay",
  selectCardButton: "Select a card",
  changeOTPChannel: {
    subtitle: "Continue another way",
    option1: "Text another code to",
    option2: "E-mail another code to",
    option3: "Pay another way",
  },
  cardSwitchUser: "To access your saved cards ",
  signIn: "sign in",
  addNewCard: "Add new card",
  uncheckedConstentWarning:
    "This field is required. If you don’t agree close a window and select different type of payment.",
  processing: "Processing",
  createAccount: "Create a new account",
  countryRegion: "Country",
  enterOrSelect: "Enter or select",
  storeCard: "Store card",
  storeCardDescription: "We need some more information to store your card.",
  storeAndPay: "Store and Pay",
  goBack: "Go back",
  storeCardLegalBeforeTerms: "By continuing, you agree to {network}'s ",
  storeCardLegalBetweenLinks: " and understand your data will be processed according to the ",
  storeCardLegalAfterPrivacy: ".",
  reviewYourDetails: "Review your details...",
  captionVerification: "Your email or mobile number will be used to verify you. Message/data rates may apply.",
  captionTermsAgreement:
    "By continuing, you agree to [scheme's] Terms and understand your data will be processed according to the Privacy Notice",
  terms: "Terms",
  privacyNotice: "Privacy Notice",
  opensInNewWindow: "Opens in a new window",
  wrongFormat: "Wrong format",
  nameWrongFormat: "Use only letters, spaces, apostrophes, or hyphens",
  requiredField: "This field is required",
  allowedLengthRange: "Enter between {min} and {max} characters",
  maximumLength: "Maximum length is {max} characters",
  invalidLength: "Invalid length",
  phoneCountryCode: "Phone country code",
  phoneNumber: "Phone number",
  dataDisclosure:
    "Click to Pay will use this information to check if you have saved cards. A one-time passcode may be sent to this mobile to confirm it’s you. Message/data rates may apply.",
  firstName: "Name",
  lastName: "Surname",
  sms: "SMS",
  email: "E-mail",
  saveCardAndPay: "Save card and Pay",
  unexpectedError: "Something went wrong. Please try again.",
}

export default englishLanguage
